import {debounce} from 'lodash';
import {useCallback, useState} from 'react';
import {DateRangePicker} from 'rsuite';

const Filters = ({filters, setFilters, setPagination, pageType = 'analysis'}) => {
  const [value, setValue] = useState(null);

  const result = {
    Positive: 'Positive',
    Negative: 'Negative'
  };

  const treatmentType = {
    IUI: 'IUI',
    IVF: 'IVF Embryo Transfer',
    OI: 'Ovulation Induction'
  };

  const isClearDisabled = !(filters.search || filters.result || filters.treatment_type || filters.beta_hcg_test_date_from || filters.beta_hcg_test_date_to);

  const handleInputChange = e => {
    const {name, value} = e.target;
    setFilters(prev => ({...prev, [name]: value}));
  };

  const handleDateChange = newValue => {
    setValue(newValue);

    if (newValue?.length === 2) {
      const [start, end] = newValue;

      const startDate = new Date(start);
      const endDate = new Date(end);

      startDate.setHours(0, 0, 0, 0);

      endDate.setHours(23, 59, 59, 999);

      const startIso = startDate.toISOString();
      const endIso = endDate.toISOString();

      setFilters(prev => ({
        ...prev,
        beta_hcg_test_date_from: startIso,
        beta_hcg_test_date_to: endIso
      }));
    } else {
      setFilters(prev => ({
        ...prev,
        beta_hcg_test_date_from: '',
        beta_hcg_test_date_to: ''
      }));
    }
  };

  const handleSearchChange = useCallback(
    debounce(value => {
      setFilters(prev => ({...prev, search: value}));
      setPagination(prev => ({...prev, pageIndex: 1})); // Reset to first page on search
    }, 500),
    []
  );

  const clearAllFilters = () => {
    setFilters({
      search: '',
      result: '',
      treatmentType: '',
      beta_hcg_test_date_from: '',
      beta_hcg_test_date_to: ''
    });
    setValue([]);
    setPagination({pageIndex: 1});
  };

  return (
    <div className='filters-container' style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
      {pageType === 'fertility' ? (
        <div className='row'>
          <div className='input-group rounded' style={{width: '250px', height: '40px'}}>
            <input
              type='search'
              className='form-control rounded'
              aria-label='Search drugs'
              placeholder='Search...'
              value={filters.search}
              onChange={e => handleSearchChange(e.target.value)}
              style={{height: '40px'}}
            />

            <span className='input-group-text border-0 bg-transparent p-0'>
              <i className='bi bi-search' style={{color: '#1b5a90', width: '20px', height: '20px', marginLeft: '10px'}}></i>
            </span>
          </div>
          <div className='col-3 col-md-3'>
            {/* <label className='form-label'>From - To</label> */}
            <DateRangePicker
              value={value}
              onChange={handleDateChange}
              placeholder='Beta-hCG Date Range'
              appearance='default'
              className='w-100 custom-date-picker'
              format='dd-MM-yyyy'
              shouldDisableDate={date => false}
            />
          </div>
          <div className='col-3 col-md-2'>
            <select className='form-select' name='result' value={filters.result} onChange={handleInputChange}>
              <option value=''>Select Result</option>
              {Object.entries(result).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div>
          <div className='col-3 col-md-2'>
            <select className='form-select' name='treatment_type' value={filters.treatmentType} onChange={handleInputChange}>
              <option value=''>Treatment Type</option>
              {Object.entries(treatmentType).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div>
          <div className='col-3 col-md-2'>
            <div style={{textAlign: 'right'}}>
              <button className='btn btn-primary' onClick={clearAllFilters} disabled={isClearDisabled}>
                Clear All Filters
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className='row'>
            <div className='col-3 col-md-3'>
              {/* <label className='form-label'>From - To</label> */}
              <DateRangePicker
                value={value}
                onChange={handleDateChange}
                placeholder='Beta-hCG Date Range'
                appearance='default'
                className='w-100 custom-date-picker'
                format='dd-MM-yyyy'
                shouldDisableDate={date => false}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Filters;
